module.exports = __webpack_public_path__ + "img/NATGAS_120X35.7aeb0952.png";